var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHome = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M19.155 20.124A1.51 1.51 0 0 1 17.66 21.5H15V16a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5v5.5H6.341c-.774 0-1.431-.604-1.494-1.326l.15-9.964L12 3.207l7.003 7.002zm3.199-7.978-10-10a.5.5 0 0 0-.707 0l-10.5 10.5a.499.499 0 0 0 .353.853.5.5 0 0 0 .354-.146l2.128-2.128-.133 8.982A2.514 2.514 0 0 0 6.341 22.5H9.5c.277 0 .5-.223.5-.5v-5.5h4V22a.5.5 0 0 0 .5.5h3.16c1.29 0 2.384-1.006 2.493-2.34l-.134-8.934 1.628 1.628a.5.5 0 0 0 .707-.707M9 11a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 0-1h-5a.5.5 0 0 0-.5.5",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgHome);
export default ForwardRef;